import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { renderToStaticMarkup } from "react-dom/server";
import { withLocalize } from "react-localize-redux";

import NavbarWeb from './components/NavbarWeb';
import Footer from './components/Footer';
import Home from './pages/Home';
import InfoHouse from './pages/infohouse/InfoHouse';
import Hatventure from './pages/hatventure/Hatventure';
import Hirilun from './pages/hirilun/Hirilun';
import GamesPrivacyPolicy from './pages/GamesPrivacyPolicy';
import TermsAndPolicy from './pages/TermsAndPolicy';
import Subventions from './pages/Subventions';

import englishTranslations from "./translations/en.json";

class App extends Component {

  constructor(props) {
    super(props);

    var availableLanguages = [
      { name: "English", code: "en" },
      { name: "Spanish", code: "es" }
    ];

    this.props.initialize({
      languages: availableLanguages,
      options: {
        renderToStaticMarkup,
        renderInnerHtml: true,
        defaultLanguage: "es"
      }
    });

    this.props.addTranslationForLanguage(englishTranslations, "en");

    //Obtiene el codigo de lenguage del navegador
    const language =
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      navigator.userLanguage;

    var languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

    //Si no hay traducción para el idioma lo establece como inglés
    if (!availableLanguages.find(function(language) {
          return language.code === languageWithoutRegionCode;
      })) {

      languageWithoutRegionCode = "en";
    }

    //Establece el idioma de la web
    this.props.setActiveLanguage(languageWithoutRegionCode);
  }

  HomeRoute() {
    return ( <Home /> );
  }

  WebRoute({ match }) {
    switch(match.params.id) {
    case 'terms_and_policy':
      return <TermsAndPolicy />;
    case 'games_privacy_policy':
      return <GamesPrivacyPolicy />;
    case 'infohouse_app':
      return <InfoHouse />;
    case 'hatventure':
      return <Hatventure />;
    case 'hirilun':
      return <Hirilun />;
    case 'subventions':
      return <Subventions />;
    default:
      return <Home />;
    }
  }

  render() {
    return (
      <Router>
        <div id="page-top">
          <NavbarWeb />

          <Route exact path="/" component={this.HomeRoute}/>
          <Route path="/:id" component={this.WebRoute} />

          <Footer />
        </div>
      </Router>
    );
  }
}

export default withLocalize(App);
